module.exports = __webpack_public_path__ + "static/img/splash-gif.0f3b1d8.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/splash-gif.gif
// module id = M/uZ
// module chunks = 10